/** @format */

import React from 'react';
import { useStyles } from './Style';
import { Card, AppBar, Tab } from '@mui/material';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { ListWebService } from './ListWebService';
import { DefineWebService } from './DefineWebService';


const WebServices = (props) => {
  const classes = useStyles();
  // const { className, ...rest } = props;

  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Card>
        <TabContext value={value}>
          <AppBar position="static">
            <TabList onChange={handleChange}>
              <Tab label="لیست وب سرویس ها" value="1" id="list" />
              <Tab label="تعریف وب سرویس" value="2" id="define" />
            </TabList>
          </AppBar>
          <TabPanel value="1">
            <ListWebService />
          </TabPanel>
          <TabPanel value="2">
            <DefineWebService />
          </TabPanel>
        </TabContext>
      </Card>
    </div>
  );
};

export default WebServices;
